import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { isAdminRole, isSuperAdminRole, isStaffRole } from '../utils/roles';
import { getDashboardPath } from '../constants/siteNav';

const ProtectedRoute = ({
  children,
  requireAdmin = false,
  requireStaff = false,
  requireSuperAdmin = false
}) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-neutral-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-4 border-gray-900 border-t-transparent mx-auto mb-4" />
          <p className="text-gray-600 font-medium">Loading…</p>
        </div>
      </div>
    );
  }

  if (!user) {
    const returnTo = `${location.pathname}${location.search}${location.hash}`;
    const loginPath = `/login?returnTo=${encodeURIComponent(returnTo)}`;
    return <Navigate to={loginPath} replace />;
  }

  if (requireSuperAdmin && !isSuperAdminRole(user.role)) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  if (requireAdmin && !isAdminRole(user.role)) {
    return <Navigate to={getDashboardPath(user)} replace />;
  }

  if (requireStaff && !isStaffRole(user.role)) {
    return <Navigate to={getDashboardPath(user)} replace />;
  }

  return children;
};

export default ProtectedRoute;
